import React from "react";
import { Badge, Modal } from "react-bootstrap";
import dayjs from "dayjs";
import { PriceWithDiscount } from "../../../components/PriceWithDiscount";

const COP = (v) => `$${Number(v ?? 0).toLocaleString("es-CO")} COP`;

const STATUS_VARIANT = {
  PAID: "success",
  PENDING: "warning",
  VOID: "secondary",
  CANCELLED: "danger",
};

function Row({ label, value }) {
  return (
    <div className="d-flex justify-content-between border-bottom py-2">
      <span className="text-muted">{label}</span>
      <span className="fw-medium text-end">{value ?? "—"}</span>
    </div>
  );
}

/**
 * Detail of a single payment + the package/subscription it paid for.
 * Opened when a student clicks a payment row.
 */
function PaymentDetailModal({ show, onHide, payment }) {
  if (!payment) return null;
  const pkg = payment.package ?? {};
  const statusVariant = STATUS_VARIANT[payment.status] ?? "secondary";

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Recibo #{payment.receipt_number || "—"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6 className="text-uppercase text-muted small mb-2">Pago</h6>
        <Row label="Fecha" value={dayjs(payment.paid_at).format("DD/MM/YYYY")} />
        <Row label="Monto" value={COP(payment.amount)} />
        <Row label="Método" value={payment.method_display ?? payment.method} />
        <Row
          label="Estado"
          value={
            <Badge bg={statusVariant}>
              {payment.status_display ?? payment.status}
            </Badge>
          }
        />
        <Row
          label="Período"
          value={
            payment.period_start && payment.period_end
              ? `${dayjs(payment.period_start).format("DD/MM/YYYY")} – ${dayjs(
                  payment.period_end
                ).format("DD/MM/YYYY")}`
              : payment.period
          }
        />

        <h6 className="text-uppercase text-muted small mb-2 mt-4">
          Paquete asociado
        </h6>
        <Row label="Paquete" value={pkg.name} />
        {pkg.final_price != null && (
          <Row
            label="Precio"
            value={
              <PriceWithDiscount
                listPrice={pkg.list_price}
                discountPct={pkg.discount_pct}
                finalPrice={pkg.final_price}
                size="sm"
              />
            }
          />
        )}
        <Row
          label="Horas"
          value={
            pkg.hours_purchased != null
              ? `${pkg.hours_balance} / ${pkg.hours_purchased} h`
              : null
          }
        />
        <Row label="Horas consumidas" value={pkg.hours_consumed != null ? `${pkg.hours_consumed} h` : null} />
        <Row label="Estado del paquete" value={pkg.status_display ?? pkg.status} />
        {pkg.end_date && (
          <Row
            label="Vence"
            value={dayjs(pkg.end_date).format("DD/MM/YYYY")}
          />
        )}
      </Modal.Body>
    </Modal>
  );
}

export { PaymentDetailModal };
